var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'dark-mode': _vm.darkMode }},[_c('Notifications'),_c('LayoutMain',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }